<template>
  <div class="examination-container">
    <div class="examination-table">
      <ul>
        <li v-for="item in cList" :key="item.categoryId">
          <a href="javascript:;" @click="toExercise(item.categoryId)">{{item.categoryName}}（{{item.finish}}/{{item.total}}）</a>
        </li>
      </ul>
    </div>
    <nothing v-show="!listlength"></nothing>
  </div>
</template>

<script>
  import {ApiGetCategory} from '../../../net/exam/index.js'
  import nothing from '../../../common/nothing.vue'
  export default {
    data: function () {
      return {
        cList: [],
      }
    },
    components:{nothing},
    computed: {
      listlength: function () {
        return this.cList.length
      }
    },
    methods: {
      getCategory: function () {
        const prames = {}
        ApiGetCategory(prames).then(res=>{
          if (res.code == 200) {
            this.cList = res.value
          }
        })
      },
      toExercise: function(id){
        this.$router.push({
          path: '/SpecialEx',
          query: {eid: id}
        })
      }
    },
    mounted: function () {
      this.getCategory()
    }
  }
</script>

<style scoped>
.examination-container{
  width: 850px;
  float: right;
  background: #fff;
  border-radius: 6px;
  min-height: 600px;
  }
.examination-table{
  padding:0 40px 20px;
}
.examination-container ul{
  margin:0;
  padding:0;
}
.examination-container ul li{
  list-style-type: none;
  padding:20px 0;
  border-bottom: 1px solid #e5e5e5;
}
.examination-container ul li a{
  font-size: 16px;
  color: #252525;
  font-weight: 400;
  text-decoration: none;
}

</style>



// WEBPACK FOOTER //
// src/components/AccExam/children/special.vue